import { render, staticRenderFns } from "./ClientesProveedores.vue?vue&type=template&id=d6ae3f58&"
import script from "./ClientesProveedores.vue?vue&type=script&lang=ts&"
export * from "./ClientesProveedores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d6ae3f58', component.options)
    } else {
      api.reload('d6ae3f58', component.options)
    }
    module.hot.accept("./ClientesProveedores.vue?vue&type=template&id=d6ae3f58&", function () {
      api.rerender('d6ae3f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ClienteProveedor/ClientesProveedores.vue"
export default component.exports